<template>
  <textarea required rows='1' data-min-rows='3' placeholder='Type text' @input="storeValue"></textarea>
</template>

<script>
export default {
  name: "TextArea",
  methods: {
    storeValue(e) {
      console.log(e.target.value)
      this.$emit("store-value", e.target.value)
    }
  }
}
</script>

<style lang="scss" scoped>
textarea{
  display: block;
  -webkit-box-sizing: border-box;
  overflow: hidden;

  padding: 1rem;
  height: 100%;
  width: 100%;
  font-size: 1.4rem;
  //margin: 50px auto;
  border-radius: .6rem;
  box-shadow: .2rem .2rem .8rem rgba(black, .3);
  border: 0;
  resize: none;
  font-family: inherit;
  font-weight: inherit;

&:focus{
   border: none;
   outline: none;
 }
}
</style>